export default __webpack_public_path__ + "6822ca8d30b39543e4a92e0ed204ee33.jpg";